/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import AppLayout from '../../../Components/Layout/Layout';
import PageTitle from '../../../Components/PageTitle/PageTitle';
import { UsuarioSd01Dto, UsuarioSd03Dto, UsuarioSd41dto } from '../../../Dtos/Cadastros/Usuarios/UsuariosDtos';
import ApiService from '../../../Config/ApiConfig';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../../../Components/Loading/Loading';

const FormUsuarioPage = () => {
    const { id } = useParams()
    const navigate = useNavigate()
    const [sd03s, setSd03s] = useState<Array<UsuarioSd03Dto>>([])
    const [sd41s, setSd41s] = useState<Array<UsuarioSd41dto>>([])
    const [loading, setLoading] = useState<boolean>(false)
    const [formData, setFormData] = useState<UsuarioSd01Dto>({
        sd01adm: 0,
        sd01credencial: {} as UsuarioSd03Dto,
        sd01email: '',
        sd01login: '',
        sd01nome: '',
        sd01representante: {} as UsuarioSd41dto
    });

    useEffect(() => {
        async function checkApi() {
            try {
                const apiService = new ApiService();

                const response = await apiService.get<boolean>("/auth/temAcesso", { params: { tarefa: "Usuarios" } })

                if (!response) {
                    navigate("/home");
                }
            } catch (error) {
                navigate("/home");
            }
        }

        checkApi();
    }, []);

    useEffect(() => {
        buscarCredenciais();
        buscarRepresentante();
        if (id != null) buscarUsuarioPeloId()
    }, [])

    const buscarUsuarioPeloId = async () => {
        try {
            setLoading(true)
            const apiService = new ApiService()

            const sd01 = await apiService.get<UsuarioSd01Dto>("/sd01Controller/buscarUsuarioPorId", {
                params: {
                    'sd01id': id
                }
            })

            setFormData(sd01)
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const buscarCredenciais = async () => {
        try {
            setLoading(true)

            const apiServer = new ApiService()

            const credenciais = await apiServer.get<Array<UsuarioSd03Dto>>("/sd01Controller/listarCredenciais")

            setSd03s(credenciais)
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const buscarRepresentante = async () => {
        try {
            setLoading(true)

            const apiServer = new ApiService()

            const reps = await apiServer.get<Array<UsuarioSd41dto>>("/sd01Controller/listarRepresentantes")

            setSd41s(reps)
        } catch (error) {
        } finally {
            setLoading(false)
        }
    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleChangeCredencial = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { value } = e.target

        const sd03 = sd03s.filter(sd => sd.sd03id === Number(value))
        if (sd03 == null || sd03.length < 1) return;
        setFormData(prev => ({
            ...prev,
            'sd01credencial': sd03[0]
        }));
    }

    const handleChangeRepresentante = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => {
        const { value } = e.target

        const sd41 = sd41s.filter(sd => sd.sd41id === Number(value))
        if (sd41 == null || sd41.length < 1) return;
        setFormData(prev => ({
            ...prev,
            'sd01representante': sd41[0]
        }));
    }

    const handleSubmit = async (e: React.FormEvent) => {
        try {
            e.preventDefault();
            setLoading(true)

            const apiServer = new ApiService()
            await apiServer.post('/sd01Controller/salvarUsuario', formData)
            navigate("/usuarios")
        } catch (error) {
        } finally {
            setLoading(false)
        }
    };

    const handleCancelar = () => {
        if (id != null) {
            buscarUsuarioPeloId()
            return
        }
        setFormData({
            sd01adm: 0,
            sd01credencial: {} as UsuarioSd03Dto,
            sd01email: '',
            sd01login: '',
            sd01nome: '',
            sd01representante: {} as UsuarioSd41dto
        })
    }

    if (loading) {
        return (
            <LoadingPage />
        )
    }
    return (
        <AppLayout>
            <PageTitle title='Usuario' />
            <FormContainer>
                <form onSubmit={handleSubmit}>
                    <FormGrid>
                        <FormField>
                            <Label>Login</Label>
                            <Input
                                type="text"
                                name="sd01login"
                                value={formData.sd01login}
                                onChange={handleChange}
                                required
                            />
                        </FormField>
                        <FormField>
                            <Label>Nome</Label>
                            <Input
                                type="text"
                                name="sd01nome"
                                value={formData.sd01nome}
                                onChange={handleChange}
                                required
                            />
                        </FormField>
                        <FormField>
                            <Label>Email</Label>
                            <Input
                                type="email"
                                name="sd01email"
                                value={formData.sd01email}
                                onChange={handleChange}
                                required
                            />
                        </FormField>
                    </FormGrid>
                    <FormGrid>
                        <FormField>
                            <Label>Credencial</Label>
                            <Select
                                name="sd01credencial"
                                value={formData.sd01credencial.sd03id}
                                onChange={handleChangeCredencial}
                                required
                            >
                                <option value="">Selecionar...</option>
                                {
                                    sd03s.map(sd03 => {
                                        return (
                                            <option selected={sd03.sd03id === formData.sd01credencial.sd03id} value={sd03.sd03id}>{sd03.sd03codigo} - {sd03.sd03nome}</option>
                                        )
                                    })
                                }
                            </Select>
                        </FormField>
                        <FormField>
                            <Label>Representante</Label>
                            <Select
                                name="sd01representante"
                                value={formData.sd01representante.sd41id}
                                onChange={handleChangeRepresentante}
                                required
                            >
                                <option value="">Selecionar...</option>
                                {
                                    sd41s.map(sd41 => {
                                        return (
                                            <option selected={sd41.sd41id === formData.sd01representante.sd41id} value={sd41.sd41id}>{sd41.sd41codigo} - {sd41.sd41nome}</option>
                                        )
                                    })
                                }
                            </Select>
                        </FormField>
                        <FormField>
                            <Label>Funcionário Multitec</Label>
                            <Select
                                name="sd01adm"
                                value={formData.sd01adm}
                                onChange={handleChange}
                                required
                            >
                                <option value={0}>Não</option>
                                <option value={1}>Sim</option>
                            </Select>
                        </FormField>
                    </FormGrid>

                    <ButtonContainer>
                        <CancelButton type="button" onClick={handleCancelar}>
                            Cancelar
                        </CancelButton>
                        <SaveButton type="submit">
                            Salvar
                        </SaveButton>
                    </ButtonContainer>
                </form>
            </FormContainer>
        </AppLayout>
    );
};

const FormContainer = styled.div`
  margin-top: 20px;
  padding: 20px !important;
  background-color: ${props => props.theme.cores.fundo.container.principal};
  border-radius: 4px;
  border: 1px solid ${props => props.theme.cores.fundo.container.secundario};
  box-shadow: ${props => props.theme.sombras.padrao}
`;

const FormGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
`;

const FormField = styled.div`
  margin-bottom: 15px;
`;

const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  color: #666;
  font-size: 0.9rem;
`;

const Input = styled.input`
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  &:focus {
    outline: none;
    border-color: #0066cc;
  }
`;

const Select = styled.select`
  width: 100%;
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  background-color: white;
  &:focus {
    outline: none;
    border-color: #0066cc;
  }
`;

const ButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 20px;
`;

const SaveButton = styled.button`
  padding: 8px 16px;
  background-color: #f39c12;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #e67e22;
  }
`;

const CancelButton = styled.button`
  padding: 8px 16px;
  background-color: transparent;
  color: #666;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  &:hover {
    background-color: #f5f5f5;
  }
`;

export default FormUsuarioPage;